module.exports = __webpack_public_path__ + "img/partner_pc1.fe74ebb1.png";